import React, { Component } from "react";
import { Link } from "react-router-dom";
import $ from "jquery/dist/jquery.js";

import * as apiConstant from "../../api/apiConstant";
import { Businesses, BsLink } from "../../config/Helper";
import { getVideoThumbFileName } from "../../config/utils";
import { lang } from "../../config/lang";
import { withRouter } from "react-router-dom";
import logApi from "../../api/logApi";
/****************************************
    Component to represent each MediaFile
    @author  CKR013
    @date    2020.05.18
    @version 0.1    
 ******************************************/
const checkSearchKey = (str) => {
  if (str === "" || str.indexOf(" ") === 0) return false;
  var patt = new RegExp(/[@#!$%^&*~{}|><"/+_()]/g);
  if (patt.test(str)) {
    return false;
  } else {
    return true;
  }
};
const mark = (str, keyword) => {
  if (keyword && checkSearchKey(keyword)) {
    const patt = new RegExp(keyword, "g");

    return str.replace(patt, `<mark>${keyword}</mark>`);
  }
  return str;
};

class MediaBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.ellipsisStyle = this.ellipsisStyle.bind(this);
  }
  componentWillMount() {
    // $('img').load(function() {
    //     $('#spinner').fadeOut();
    // });
  }

  componentDidMount() {
    if (this.props.media_type === 0) {
      window.checkSize();
    }
    setTimeout(this.ellipsisStyle, 400);
    window.addEventListener("resize", this.waitAndEllipsis);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.waitAndEllipsis);
  }

  componentWillReceiveProps(newProps) {
    // this.getTitle();
  }
  componentDidUpdate() {
    if (this.props.media_type === 0) {
      window.checkSize();
    }
    setTimeout(this.ellipsisStyle, 400);
    window.onClose();
  }

  onErrorImageLoad() {
    $("#img_" + this.props.id).attr("src", "/assets/images/no_image.png");
  }

  waitAndEllipsis() {
    setTimeout(this.ellipsisStyle, 800);
  }

  ellipsisStyle() {
    window.ellipsisMe(
      "#media_" +
        this.props.business +
        "_" +
        this.props.id +
        "_" +
        this.props.media_type
    );
  }

  render() {
    var video_name = "";
    if (
      this.props.image !== undefined &&
      this.props.image !== null &&
      this.props.media_type === 1
    ) {
      var name_without_extention = this.props.image.slice(
        0,
        this.props.image.length - 4
      );
      video_name = name_without_extention + ".mp4";
    }
    var popupClass = "image-popup";
    var fileName = this.props.image;
    if (this.props.media_type === 1) {
      popupClass = "play-video";
      fileName = fileName.substr(0, fileName.length - 4) + ".mp4";
    }

    return (
      <div className="project">
        <Link
          to={apiConstant.link(this.props.business, this.props.id, fileName)}
          // className={popupClass}
          caption={
            lang(Businesses[this.props.business]) +
            " / " +
            (this.props.title ? this.props.title : "")
          }
        >
          <div className="img">
            {(this.props.image === undefined || this.props.image === null) && (
              <img
                src=""
                data-desktop-image="/assets/images/no_image.png"
                data-tablet-image="/assets/images/no_image.png"
                data-mobile-image="/assets/images/no_image.png"
                className="img-fluid"
                alt="media-block-no"
              />
            )}
            {this.props.media_type === 0 && (
              <div data-lightbox="gallery">
                <img
                  id={`img_${this.props.id}`}
                  onError={() => this.onErrorImageLoad()}
                  src=""
                  data-desktop-image={apiConstant.thumbnail(
                    this.props.business,
                    this.props.id,
                    this.props.image
                  )}
                  data-tablet-image={apiConstant.tablet(
                    this.props.business,
                    this.props.id,
                    this.props.image
                  )}
                  data-mobile-image={apiConstant.mobile(
                    this.props.business,
                    this.props.id,
                    this.props.image
                  )}
                  className="img-fluid"
                  alt="media-block-photo"
                ></img>
              </div>
            )}
            {this.props.media_type === 1 && (
              <div>
                <img
                  id={`img_${this.props.id}`}
                  onError={() => this.onErrorImageLoad()}
                  src={apiConstant.thumbnail(
                    this.props.business,
                    this.props.id,
                    getVideoThumbFileName(this.props.image)
                  )}
                  // data-desktop-image={apiConstant.thumbnail(this.props.business, this.props.id, this.props.image)}
                  // data-tablet-image={apiConstant.tablet(this.props.business, this.props.id, this.props.image)}
                  // data-mobile-image={apiConstant.mobile(this.props.business, this.props.id, this.props.image)}
                  className="img-fluid"
                  alt="media-block-video"
                />
                <p
                  href={apiConstant.desktop(
                    this.props.business,
                    this.props.id,
                    video_name
                  )}
                  className="play-video video-icon"
                  onClick={() =>
                    logApi.log({
                      title: this.props.title,
                      lang: localStorage.getItem("language"),
                      type: "동화상",
                    })
                  }
                >
                  <i className="fa fa-play" aria-hidden="true"></i>
                </p>
              </div>
            )}
          </div>
        </Link>
        <div className="text">
          <h4 className="price">{lang(Businesses[this.props.business])}</h4>
          {/* <span dangerouslySetInnerHTML={{__html: this.props.title}}></span> */}
          {/* <Link to={`/${BsLink[this.props.business]}/${this.props.id}`}>

                    </Link> */}
          <div
            onClick={() => {
              this.props.history.push(
                `/${BsLink[this.props.business]}/${this.props.id}?page=${
                  this.props.currentPage
                }`
              );
            }}
            className="blog-title"
          >
            <h3
              // id={`media_${this.props.business}_${this.props.id}_${this.props.media_type}`}
              className="ellipsis-title"
              caption={this.props.title}
              style={{ textAlign: "center" }}
              dangerouslySetInnerHTML={{
                __html: this.props.title
                  ? mark(this.props.title, this.props.keyword)
                  : "<font style='visibility: hidden;'>no title</font> ",
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(MediaBlock);
